import React, { PropTypes } from 'react'
import map from 'lodash/map'

import api from '../../api'

import AutoComplete from 'material-ui/AutoComplete'
import ContentAdd from 'material-ui/svg-icons/content/add'
import ContentRemove from 'material-ui/svg-icons/content/remove'
import ArrowUpward from 'material-ui/svg-icons/navigation/arrow-upward'
import ArrowDownward from 'material-ui/svg-icons/navigation/arrow-downward'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import { List, ListItem } from 'material-ui/List'
import TextField from 'material-ui/TextField'

const styles = {
  actionButton: {
    marginLeft: '5px'
  }
}

class MenuEditor extends React.Component<any, any> {
  constructor (props) {
    super(props)
    this.state = { cmsPages: [] }
  }

  componentDidMount () {
    api.get('admin/cms_pages')
      .then((res) => res.json())
      .then((body = []) => {
        const cmsPages = this.props.pageFilter
          ? body.filter(this.props.pageFilter)
          : body

        this.setState({ cmsPages })
      })
  }

  render () {
    const { value, onChange, errorText } = this.props

    const renderItems = menuItems => {
      return map(menuItems, (item, index) => (
        <ListItem
          disableKeyboardFocus
          key={index}
          nestedItems={
            // only allow one level of nesting
            menuItems === value
              ? renderItems(item.children || [])
              : undefined
          }
        >
          <div style={{ float: 'right', marginRight: '40px', marginTop: '40px' }}>
            {index > 0 &&
              <FloatingActionButton
                style={styles.actionButton} mini onClick={(e) => {
                  const temp = menuItems[index - 1]
                  menuItems[index - 1] = item
                  menuItems[index] = temp
                  onChange(e, value)
                }}
              >
                <ArrowUpward />
              </FloatingActionButton>}
            {index < menuItems.length - 1 &&
              <FloatingActionButton
                style={styles.actionButton} mini onClick={(e) => {
                  const temp = menuItems[index + 1]
                  menuItems[index + 1] = item
                  menuItems[index] = temp
                  onChange(e, value)
                }}
              >
                <ArrowDownward />
              </FloatingActionButton>}
            <FloatingActionButton
              style={styles.actionButton} mini secondary onClick={(e) => {
                menuItems.splice(index, 1)
                onChange(e, value)
              }}
            >
              <ContentRemove />
            </FloatingActionButton>
          </div>
          <div>
            <TextField
              hintText='Link text'
              value={item.name}
              onChange={(e, newText) => {
                item.name = newText
                onChange(e, value)
              }}
            />
            <AutoComplete
              hintText='Page url'
              filter={AutoComplete.caseInsensitiveFilter}
              dataSource={this.state.cmsPages.map((cmsPage) => ({
                text: cmsPage.slug,
                value: cmsPage.slug
              }))}
              searchText={item.slug}
              onNewRequest={(e, cmsPageIndex) => {
                item.slug = this.state.cmsPages[cmsPageIndex].slug
                onChange(e, value)
              }}
              onUpdateInput={(newValue) => {
                item.slug = newValue
                onChange({}, value)
              }}
            />
          </div>
        </ListItem>
      )).concat(
        <ListItem key='add_new'>
          <FloatingActionButton
            mini onClick={(e) => {
              menuItems.push({ name: '', slug: '', children: [] })
              onChange(e, value)
            }}
          >
            <ContentAdd />
          </FloatingActionButton>
        </ListItem>
      )
    }

    return (
      <div>
        <List>{renderItems(value)}</List>
        {errorText &&
          <p style={{ color: 'red' }}>
            All fields, except top-level urls, must not be empty
          </p>}
      </div>
    )
  }
}

// @ts-ignore
MenuEditor.propTypes = {
  value: PropTypes.arrayOf(PropTypes.object),
  pageFilter: PropTypes.func
}

// @ts-ignore
MenuEditor.defaultProps = { value: [] }

export default MenuEditor
